export const lastSeenList = [
    {name: 'All', id: ''},
    {name: 'Last 1 month', id: 1},
    {name: 'Last 3 months', id: 3},
    {name: 'Last 6 months', id: 6}
]
    